(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["mg-card-swatches"] && !Shopify.designMode) return;
  try {
    (function(){
    if(window.__mgsw)return;window.__mgsw=1;
    function fmt(c){var s=(c/100).toFixed(2).replace('.',',');return s.replace(',00','')+' €'}
    function badge(p,c){if(!(c>p))return '';var sv=c-p;return c>=10000?'Ahorras '+fmt(Math.round(sv/100)*100):'-'+Math.floor(sv*100/c)+' %'}
    document.addEventListener('click',function(e){
      var b=e.target.closest('.mgsw');if(!b)return;
      e.preventDefault();e.stopPropagation();
      var card=b.closest('product-card')||b.closest('.product-card')||b.parentNode.parentNode;
      card.querySelectorAll('.mgsw').forEach(function(x){x.classList.toggle('is-on',x===b)});
      var p=+b.dataset.p,c=+b.dataset.c,id=b.dataset.v;
      card.querySelectorAll('a[href*="/products/"]').forEach(function(a){try{var u=new URL(a.href,location.origin);u.searchParams.set('variant',id);a.href=u.pathname+u.search}catch(_){}}
      );
      if(b.dataset.img){var g=card.querySelector('.card-gallery'),im=null;if(g){var r=g.getBoundingClientRect();var hit=document.elementsFromPoint(r.left+r.width/2,r.top+r.height/2);for(var i=0;i<hit.length;i++){if(hit[i].tagName==='IMG'&&g.contains(hit[i])){im=hit[i];break}}im=im||g.querySelector('img')}if(im){im.removeAttribute('srcset');im.removeAttribute('sizes');im.src=b.dataset.img}}
      var pr=card.querySelector('[data-mgpr]');
      if(pr){pr.querySelector('[data-now]').textContent=fmt(p);var w=pr.querySelector('[data-was]');w.textContent=c>p?fmt(c):'';pr.classList.toggle('is-sale',c>p)}
      var bd=card.querySelector('[data-mgbadge]');
      if(bd){var t=badge(p,c);bd.textContent=t;bd.hidden=!t}
    },true);
  })();
  } catch(e) { console.error(e); }
})();

})();
